<template>
  <section
    id="toruk-magic-intro"
    class="py-12 sm:py-16 md:py-20 lg:py-24 xl:py-32 relative overflow-hidden"
  >
    <div
      class="absolute inset-0 bg-gradient-to-br from-[#0b105d] via-[#0b105d]/95 to-[#fe6d0d]/40"
    ></div>
    <div class="absolute inset-0 bg-black opacity-50"></div>

    <div class="container mx-auto px-4 sm:px-6 lg:px-8 xl:px-12 relative z-10">
      <div class="max-w-xs sm:max-w-2xl md:max-w-3xl lg:max-w-4xl mx-auto text-center">
        <div
          class="glass-morphism rounded-2xl sm:rounded-3xl p-6 sm:p-8 md:p-10 lg:p-16 shadow-2xl"
          data-aos="zoom-in"
        >
          <div class="glow-effect"></div>
          <h2
            class="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-black text-transparent bg-clip-text bg-gradient-to-r from-[#fe6d0d] to-[#ffb47c] mb-6 sm:mb-8 animate-gradient"
          >
            {{ $t('torukMagic.title') }}
          </h2>
          <p
            class="text-base sm:text-lg md:text-xl text-[#f4f4f4]/90 mb-8 sm:mb-10 leading-relaxed"
            data-aos="fade-up"
            data-aos-delay="100"
          >
            {{ $t('torukMagic.description') }}
          </p>
          <!-- <div
            class="inline-flex items-center gap-2 sm:gap-3 px-4 sm:px-6 py-2 sm:py-3 bg-gradient-to-r from-[#fe6d0d]/20 to-[#ffb47c]/20 rounded-full border border-[#ffb47c]/40 backdrop-blur-sm"
            data-aos="fade-up"
            data-aos-delay="200"
          >
            <div class="w-2 h-2 sm:w-3 sm:h-3 bg-green-400 rounded-full animate-pulse"></div>
            <p
              class="text-lg sm:text-xl md:text-2xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-[#fe6d0d] to-[#ffb47c]"
            >
              {{ $t('magicSaaS.deepTech') }}
            </p>
          </div> -->
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts"></script>

<style scoped>
.glass-morphism {
  background: rgba(11, 16, 93, 0.5);
  backdrop-filter: blur(12px) saturate(150%);
  -webkit-backdrop-filter: blur(12px) saturate(150%);
  border: 1px solid rgba(254, 109, 13, 0.2);
  position: relative;
  overflow: hidden;
}

.glow-effect {
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: radial-gradient(circle, rgba(254, 109, 13, 0.15) 0%, rgba(254, 109, 13, 0) 60%);
  animation: rotateGlow 15s linear infinite;
  pointer-events: none;
}

@keyframes rotateGlow {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.animate-gradient {
  animation: gradientFlow 5s ease infinite;
  background-size: 200% 200%;
}

@keyframes gradientFlow {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}
</style>
